import fetch from 'node-fetch'

import is_server from './is_server'
import isEmpty from './lodashUtils/isEmpty'
const timeoutDuration = 90000

export function triggerSimpleAjax({
	locale = '',
	url,
	method = 'POST',
	body = {},
	onSuccess,
	onFailure,
	customHeader = {},
	requesHeaders = null,
	isHandledError = false,
}) {
	let headerObject = {
		'Content-Type': 'application/json',
		locale: is_server()
			? locale || ''
			: locale || sessionStorage.getItem('locale') || '',
	}

	if (customHeader && !isEmpty(customHeader)) {
		headerObject = {
			...headerObject,
			...customHeader,
		}
	}

	const headers = headerObject

	const requestDetails = {
		method,
		mode: 'cors',
		credentials: 'include',
		headers,
	}

	if (method !== 'GET') requestDetails.body = JSON.stringify(body)

	/**
	 * This promise will start the network request and will return the data from the server
	 * or throw errors in case the network request fails
	 */

	const request = new Promise((resolve, reject) => {
		// console.log({ url })
		// console.log(body);
		// console.log(JSON.stringify(body));
		// console.log(method);
		// console.log(headers);

		fetch(url, requesHeaders || requestDetails)
			.then(data => {

				if (data.status === 200) {
					let jsonData = {}
					try {
						jsonData = data.json()
					} catch (e) {
						jsonData = {}
					}
					return jsonData
				} else if (data.status === 400 && isHandledError) {
					return data.json().then(result => {
						return {
							...result,
							statusCode: 400,
						}
					})
				} else if (data.status === 404) {

					return {
						statusText: 'Not Found',
						statusCode: 404,
						data: {
							message: "Not found"
						}
					}

				}
				else {
					return reject(data)
				}
			})
			.then(result => {
				resolve(result)
			})
			.catch(err => {
				// console.log('Something went wrong!', url)

				reject(err)
			})
	})

	/**
	 * Will execute a reject action after the `timeoutDuration`
	 * If it executes this will mark the network request as timed out
	 */
	const networkTimeOut = reject => {
		return setTimeout(() => {
			const errorObject = Error(
				JSON.stringify({
					status: `Request timed out!`,
					url,
				}),
			)
			reject(errorObject)
		}, timeoutDuration)
	}

	/**
	 * Starts both the timeout and the network request
	 * and resolves whichever executes first.
	 */
	new Promise((resolve, reject) => {
		const timeoutId = networkTimeOut(reject)
		request
			.then(result => {
				clearTimeout(timeoutId)
				onSuccess(result)
				resolve(result)
			})
			.catch(error => {
				clearTimeout(timeoutId)
				onFailure && onFailure(error)
				reject(error)
			})
	})
}
